import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { DropdownMenuItemIndicator } from '../../patched-dropdown/Dropdown.mjs';
import { dropdownItemIndicator } from './itemIndicator.vanilla.mjs';

const DropdownItemIndicator = forwardRef(({ className: classNameFromProps, ...props }, forwardedRef) => {
  const className = classNames(dropdownItemIndicator, classNameFromProps);
  return /* @__PURE__ */ jsx(
    DropdownMenuItemIndicator,
    {
      "data-scope": "dropdown",
      "data-part": "item-indicator",
      className,
      ref: forwardedRef,
      ...props
    }
  );
});

export { DropdownItemIndicator };
//# sourceMappingURL=ItemIndicator.mjs.map
